import React, { useEffect, useState } from "react";
import Uppy from "@uppy/core";
import { DashboardModal } from "@uppy/react";
import GoldenRetriever from "@uppy/golden-retriever";
import Tus from "@uppy/tus";
import "@uppy/core/dist/style.min.css";
import "@uppy/dashboard/dist/style.min.css";
import "@uppy/webcam/dist/style.min.css";

const VideoTusUpload = (props) => {
  const [isOpen, setOpen] = useState(false);
  const [uppy, setUppy] = useState(null);

  useEffect(() => {
    // Create a new instance of Uppy
    const newUppy = new Uppy({
      restrictions: {
        maxNumberOfFiles: 1,
        allowedFileTypes: ["video/mp4"],
      },
    });

    // Add Tus plugin for resumable uploads
    newUppy.use(Tus, {
      endpoint: process.env.REACT_APP_TUS_URL,
      protocol: "https",
    });

    // Add GoldenRetriever plugin for persistent upload state
    newUppy.use(GoldenRetriever, {
      indexedDB: { maxFileSize: Infinity, maxTotalSize: Infinity },
    });

    // Create DashboardModal instance for displaying upload dashboard
    // eslint-disable-next-line no-new
    new DashboardModal({
      uppy: newUppy,
      closeModalOnClickOutside: true,
      closeModalOnEscape: true,
      onRequestClose: () => setOpen(false),
    });

    // Event listener for upload start
    newUppy.on("upload", () => {
      setOpen(true);
    });

    newUppy.on("upload-error", (file, error, response) => {
      console.error("Upload error:", { file, error, response });
    });

    // Event listener for upload completion
    newUppy.on("complete", (result) => {
      const videoFile = result?.successful?.[0];
      props?.handleFile(videoFile?.uploadURL);
      setOpen(false);
    });

    // Set the Uppy instance to state
    setUppy(newUppy);

    // Cleanup function
    return () => {
      if (newUppy) {
        newUppy.close();
      }
    };
  }, []);

  return (
    <div className="width-outer-up">
      <div className="body d-flex flex-col py-1">
        {uppy && (
          <DashboardModal
            uppy={uppy}
            open={isOpen}
            closeModalOnClickOutside
            closeModalOnEscape
            onRequestClose={() => {
              setOpen(false);
            }}
          />
        )}
        <div className="flex-p" onClick={() => setOpen(true)}>
          <i className="fa fa-upload upload-ic"></i>
          <span className="img-upload-label">{`${props.label}`}</span>
        </div>
        {(props.errors || props.touched) && (
          <p className="error-msg mt-4">{props.errors}</p>
        )}
      </div>
    </div>
  );
};

export default VideoTusUpload;
